import React from 'react';
import './loadingSpinner.css';

const LoadingSpinner = () => {
    return (
        <div className="spinner-container" data-testid="loading-spinner">
            <div className="spinner"></div>
        </div>
    );
};

export default LoadingSpinner;
